export default function RefundPolicy() {
  return (
    <div className="page">
      <h2>Refund Policy</h2>
      <p>
        Payments for certification and evaluations are non-refundable once the
        review process has started.
      </p>
    </div>
  );
}
